import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {WebsiteReviewContainerModel} from '../../../../../../models';


@Injectable({providedIn: 'root'})

export class WebsiteReviewService extends BaseApiTemplateService<WebsiteReviewContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-reviews';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-reviews';
    this.httpClient = http;
  }
}
